const domain_info = {
	/* --------------------------- DOMAIN INFO SECTION -------------------------- */
	cancel_button: "Cancel domain",

	/* ------------------------------ CANCEL DIALOG ----------------------------- */
	cancel_dialog: {
		description:
			"To confirm, please enter the domain name <strong>{{domain_name}}</strong> in the input field below.",
		info: "After cancellation, your domain will remain active until <strong>{{renewal_date}}</strong>. After this date, the domain name will expire. Notice! Termination of a domain is final.",
		success_message: "Your domain name has been successfully cancelled.",
		title: "Cancel domainname",
		validation_input: {
			label: "Enter domain name",
			placeholder: "Enter the domain name",
		},
	},
	/* ----------------------------- MANAGE SECTION ----------------------------- */
	manage: {
		add_button: "Register domain",
		table: {
			details: "Details",
			dns: { button: "To DNS", title: "DNS" },
			domain_name: "Domain name",
			holder: "Holder",
			price: "Price",
			registration_date: "Registration date",
			renewal_date: "Renewal date",
			status: {
				active: "Active",
				cancellation_pending: "Cancellation pending",
				cancelled: "Cancelled",
				error: "Failed",
				in_progress: "In progress",
				obsolete: "Obsolete",
				title: "Subscription",
			},
		},
		title: "Manage",
	},
	tiles: {
		autorenew_tile: {
			bttn: "Enable autorenew",
			description: "Autorenew status",
			dialog: {
				description:
					"Are you sure you want to enable autorenew for <strong>{{domain_name}}</strong>?",

				messages: {
					success: "Autorenew enabled for <strong>{{domain_name}}</strong>",
				},
				title: "Autorenew domain name",
			},
			state: ["Disabled", "Enabled"],
			title: "Autorenew",
		},
		contact_tiles: {
			admin: "Administration contact",
			billing: "Billing contact",
			tech: "Technical contact",
		},
		debtor_tile: {
			business: "Business",
			company_name: "Company name",
			debtor_code: "Debtor number",
			name: "Name",
			private: "Private",
			title: "Debtor",
		},
		holder_tile: {
			address: "Address",
			change_holder: "Change holder",
			coc_number: "CoC number",
			company_name: "Company name",
			email_address: "Email address",
			first_name: "First name",
			last_name: "Last name",
			middle_name: "Middle name",
			phone_number: "Phone number",
			salutation: "Salutation",
			title: "Holder",
			vat_number: "VAT number",
		},
		info_tile: {
			authorization_code: {
				button: "Request token",
				no_token: "Check your email for the Authorization Code",
				title: "Authorization code (token)",
			},
			auto_renew_date: "Autorenew date",
			dns_sec: { button: "Open DNSsec", title: "DNSsec" },
			expire_date: "Expiration date",
			local_presence: {
				tip: "Proxy tooltip",
				title: "Proxy",
				true: "In use",
			},
			price: { tip: "The price at renewal may vary slightly.", title: "Actual price" },
			registration_date: "Registration date",
			title: "Domain information",
		},
		nameserver_tile: {
			change_ns_group: "Change NS-group",
			nameserver: "Nameserver",
			title: "Nameservers",
			used_nameservers_for_domain: "The following nameservers will be used for the domain(s):",
		},
		oxxa_error_tile: {
			description:
				"(Superuser-Only) \n It appears that a connection cannot be made to Oxxa at this time, this is required to access certain domain-holder information. Please try again later or contact a developer.",
			domain_info_not_available:
				"Please note! The information below could not be updated. The information below may not be up to date.",
			mismatch_on_identities:
				"Please note! The holder information below may not match. Please contact Tuxis support.",
		},
	},

	/* ----------------------------- TRANSFER DIALOG ---------------------------- */
	transfer_dialog: {
		cancel_checkbox: {
			label: "Cancel this domain by <strong>{{date}}</strong>.",
			tooltip:
				"A domain name must be cancelled 30 days prior to the renewal date. Otherwise it will be billed for the next year",
		},
		description:
			"If the code is not visible on the current page after the request, it will be emailed to the following email address:\n<strong>{{email_address}}</strong>",
		error_messages: {
			cancel_domain:
				"Notice! The domain name MUST be transferred before {{date}} otherwise it will be <strong>released</strong> as of {{expire_date}} and can be registered by third parties!",
			renewal_date:
				"The domain name must be transferred before <strong>{{date}}</strong>, otherwise this domain will be renewed and billed.",
			unknown:
				"Something went wrong while requesting the transfer code, please try again or contact our support department.",
		},
		success_message:
			"The transfer code was successfully sent to the domain holder's email address.",
		title: "Request transfer code",
	},
};

export default domain_info;
